/* PureBalance Redesign JS — pb- namespaced */
(function(){
'use strict';
if(window.__pbInit)return;window.__pbInit=true;
var FREE_SHIP = window.PB_FREE_SHIP_CENTS || 5000000; /* 50 000 Ft */
function fmt(cents){
  var cur = (window.PB_CURRENCY || 'HUF').toUpperCase();
  var amount = cents/100;
  try {
    var frac = (cur === 'HUF') ? 0 : 2;
    return new Intl.NumberFormat('hu-HU', {style:'currency', currency:cur, minimumFractionDigits:frac, maximumFractionDigits:frac}).format(amount);
  } catch(e){
    return Math.round(amount).toLocaleString('hu-HU')+' '+cur;
  }
}

/* ---- kosár-upsell: extra üveg (orig = egy üveg ára az 1+1 csomagban) ---- */
var PB_UPSELL = {
  'purebalance-testosteron-booster': {id:56874285531476, price:'11.990 Ft', orig:'14.995 Ft'},
  'purebalance-laxative-max': {id:56874288808276, price:'8.990 Ft', orig:'11.495 Ft'},
  'purebalance-multivitamin': {id:56874288939348, price:'8.990 Ft', orig:'11.495 Ft'},
  'purebalance-immunostimulant-pro': {id:56874289070420, price:'8.990 Ft', orig:'11.495 Ft'},
  'purebalance-vision-care': {id:56874289332564, price:'8.990 Ft', orig:'11.495 Ft'},
  'purebalance-gut-probiotic-plus': {id:56874289627476, price:'9.990 Ft', orig:'12.495 Ft'},
  'purebalance-stress-control-relief': {id:56874291134804, price:'8.990 Ft', orig:'11.495 Ft'},
  'purebalance-weight-loss': {id:56874291364180, price:'9.990 Ft', orig:'12.495 Ft'},
  'purebalance-hormone-balance': {id:56874291822932, price:'9.490 Ft', orig:'11.995 Ft'},
  'purebalance-joint-support': {id:56874292052308, price:'9.490 Ft', orig:'11.995 Ft'}
};
/* ---- cross-sell: kiegészítő termék 1+1 csomagja (cink összeadva max. 25 mg/nap) ---- */
var PB_CROSS = {
  'purebalance-testosteron-booster': {h:'purebalance-stress-control-relief', name:'Stress Control & Relief™', vid:56266718708052, price:'22.990 Ft', why:'Esti levezető rutin a napközbeni lendület mellé.'},
  'purebalance-stress-control-relief': {h:'purebalance-hormone-balance', name:'Hormone Balance™', vid:56266686988628, price:'23.990 Ft', why:'Az esti nyugalom mellé a belső egyensúly napi rutinja.'},
  'purebalance-hormone-balance': {h:'purebalance-stress-control-relief', name:'Stress Control & Relief™', vid:56266718708052, price:'22.990 Ft', why:'A belső egyensúly mellé egy esti, levezető rutin.'},
  'purebalance-weight-loss': {h:'purebalance-gut-probiotic-plus', name:'Gut Probiotic Plus™', vid:56266724278612, price:'24.990 Ft', why:'Az anyagcsere-rutin mellé a bélflóra napi támogatása.'},
  'purebalance-gut-probiotic-plus': {h:'purebalance-weight-loss', name:'Weight Loss™', vid:56266695016788, price:'24.990 Ft', why:'A bélflóra-rutin mellé egy tudatos anyagcsere-rutin.'},
  'purebalance-laxative-max': {h:'purebalance-gut-probiotic-plus', name:'Gut Probiotic Plus™', vid:56266724278612, price:'24.990 Ft', why:'Az alkalmi emésztéstámogatás mellé a bélflóra napi rutinja.'},
  'purebalance-multivitamin': {h:'purebalance-vision-care', name:'Vision Care™', vid:56266728603988, price:'22.990 Ft', why:'A napi vitaminok mellé a képernyő előtt dolgozó szemed rutinja.'},
  'purebalance-immunostimulant-pro': {h:'purebalance-gut-probiotic-plus', name:'Gut Probiotic Plus™', vid:56266724278612, price:'24.990 Ft', why:'Az immunrutin mellé a bélflóra napi támogatása.'},
  'purebalance-vision-care': {h:'purebalance-stress-control-relief', name:'Stress Control & Relief™', vid:56266718708052, price:'22.990 Ft', why:'Hosszú képernyős nap után egy esti, levezető rutin.'},
  'purebalance-joint-support': {h:'purebalance-multivitamin', name:'Multivitamin™', vid:56266767139156, price:'22.990 Ft', why:'Az ízületi rutin mellé a teljes napi vitaminpótlás.'}
};
function buildCrossHtml(cart){
  var cross=null;
  for(var i=0;i<cart.items.length;i++){
    var c=PB_CROSS[cart.items[i].handle];
    if(c){cross=c;break;}
  }
  if(!cross) return '';
  var inCart=cart.items.some(function(it){return it.handle===cross.h||it.variant_id===cross.vid;});
  if(inCart) return '';
  return '<div class="pb-sc-upsell pb-sc-cross" id="pb-sc-cross">'
    +'<span class="pb-sc-upsell-badge">Jól kiegészíti</span>'
    +'<div class="pb-sc-upsell-row"><div class="pb-sc-upsell-text">'
    +'<p class="pb-sc-upsell-h">'+cross.name+' — 1+1 csomag</p>'
    +'<p class="pb-sc-upsell-s">'+cross.why+' <span class="pb-sc-upsell-new">'+cross.price+'</span> (2 üveg)</p></div></div>'
    +'<button type="button" class="pb-sc-upsell-btn" data-pb-upsell-add="'+cross.vid+'">Hozzáadom a kosárhoz</button>'
    +'</div>';
}
function buildUpsellHtml(cart){
  var ids = Object.keys(PB_UPSELL).map(function(k){return PB_UPSELL[k].id;});
  var already = cart.items.some(function(it){return ids.indexOf(it.variant_id) !== -1;});
  var html='';
  var match=null, title=null, img=null;
  if(!already){
    for(var i=0;i<cart.items.length;i++){
      var it=cart.items[i];
      if(PB_UPSELL[it.handle]){match=PB_UPSELL[it.handle];title=it.product_title;img=it.image;break;}
    }
  }
  if(match){
    var imgHtml = img ? ('<img src="'+img.replace(/(\.[a-z]+)(\?|$)/,'_120x$1$2')+'" alt="">') : '';
    html+='<div class="pb-sc-upsell" id="pb-sc-upsell">'
      +'<span class="pb-sc-upsell-badge">Extra ajánlat</span>'
      +'<div class="pb-sc-upsell-row">'+imgHtml
      +'<div class="pb-sc-upsell-text"><p class="pb-sc-upsell-h">Tedd mellé még 1 üveggel — kedvezőbb áron!</p>'
      +'<p class="pb-sc-upsell-s">'+title+' — még 1 üveg <span class="pb-sc-upsell-old">'+match.orig+'</span> <span class="pb-sc-upsell-new">'+match.price+'</span></p></div></div>'
      +'<button type="button" class="pb-sc-upsell-btn" data-pb-upsell-add="'+match.id+'">Igen, kérem kedvezménnyel</button>'
      +'</div>';
  }
  html+=buildCrossHtml(cart);
  return html;
}
document.addEventListener('click',function(ev){
  var b=ev.target.closest('[data-pb-upsell-add]');
  if(!b)return;
  var vid=b.getAttribute('data-pb-upsell-add');
  b.disabled=true;b.textContent='...';
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(vid),quantity:1}]})})
    .then(function(r){return r.json();})
    .then(function(){refreshCart();})
    .catch(function(){b.disabled=false;});
});

/* ---- scroll reveal ---- */
var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('pb-on');io.unobserve(e.target);}});},{threshold:.12}) : null;
function observeAll(){document.querySelectorAll('.pb-reveal:not(.pb-on)').forEach(function(el){io?io.observe(el):el.classList.add('pb-on');});}

/* ---- countdown ---- */
function initCountdowns(){
  document.querySelectorAll('[data-pb-countdown]').forEach(function(box){
    if(box.__pbCd)return;box.__pbCd=true;
    var end = new Date(box.getAttribute('data-pb-countdown'));
    if(isNaN(end)){box.style.display='none';return;}
    var hEl=box.querySelector('.pb-cd-h'),mEl=box.querySelector('.pb-cd-m'),sEl=box.querySelector('.pb-cd-s'),dEl=box.querySelector('.pb-cd-d');
    function t(){
      var d=end-new Date();
      if(d<=0){box.style.display='none';clearInterval(iv);return;}
      var days=Math.floor(d/864e5);
      if(dEl){dEl.textContent=days;}
      var rem=dEl?d%864e5:d;
      if(hEl)hEl.textContent=String(Math.floor(rem/36e5)).padStart(2,'0');
      if(mEl)mEl.textContent=String(Math.floor(rem%36e5/6e4)).padStart(2,'0');
      if(sEl)sEl.textContent=String(Math.floor(rem%6e4/1e3)).padStart(2,'0');
    }
    t();var iv=setInterval(t,1000);
  });
}

/* ---- accordion ---- */
document.addEventListener('click',function(ev){
  var btn=ev.target.closest('.pb-qa>button');
  if(!btn)return;
  var qa=btn.closest('.pb-qa'),body=qa.querySelector('.pb-body'),open=qa.classList.toggle('pb-open');
  body.style.maxHeight=open?body.scrollHeight+'px':'0';
});

/* ---- toast ---- */
var toastTmr;
function toast(msg){
  var t=document.getElementById('pb-toast');if(!t)return;
  t.querySelector('.pb-toast-msg').textContent=msg;
  t.classList.add('pb-on');clearTimeout(toastTmr);
  toastTmr=setTimeout(function(){t.classList.remove('pb-on');},2600);
}

/* ---- side cart ---- */
function $(id){return document.getElementById(id);}
function openCart(){var sc=$('pb-sidecart'),ov=$('pb-overlay');if(sc){sc.classList.add('pb-on');ov.classList.add('pb-on');document.body.classList.add('pb-cart-open');refreshCart();}}
function closeCart(){var sc=$('pb-sidecart'),ov=$('pb-overlay');if(sc){sc.classList.remove('pb-on');ov.classList.remove('pb-on');document.body.classList.remove('pb-cart-open');}}
window.pbOpenCart=openCart;window.pbCloseCart=closeCart;

function refreshCart(){
  fetch('/cart.js').then(function(r){return r.json();}).then(renderCart).catch(function(){});
}
function updateHeaderCount(cart){
  document.querySelectorAll('.cart-count-bubble span[aria-hidden]').forEach(function(el){el.textContent=cart.item_count;});
}
function renderCart(cart){
  updateHeaderCount(cart);
  var box=$('pb-sc-items');if(!box)return;
  var cnt=$('pb-sc-count');if(cnt)cnt.textContent=cart.item_count?('('+cart.item_count+' tétel)'):'';
  if(!cart.items.length){
    box.innerHTML='<div class="pb-sc-empty">A kosarad még üres.<br>Válassz egy csomagot, és indítsd el a változást! 🌿</div>';
  }else{
    box.innerHTML=cart.items.map(function(it,x){
      var img=it.image?('<img src="'+it.image.replace(/(\.[a-z]+)(\?|$)/,'_120x$1$2')+'" alt="">'):'💊';
      var vt=(it.variant_title&&it.variant_title!=='Default Title'&&it.variant_title!=='Default')?it.variant_title:'';
      return '<div class="pb-sc-item">'+
        '<span class="pb-im">'+img+'</span>'+
        '<div class="pb-t"><b>'+it.product_title+'</b><span>'+vt+'</span>'+
        '<div><span class="pb-qmini"><button data-pb-line="'+(x+1)+'" data-pb-q="'+(it.quantity-1)+'">−</button><b>'+it.quantity+'</b><button data-pb-line="'+(x+1)+'" data-pb-q="'+(it.quantity+1)+'">+</button></span></div></div>'+
        '<div style="text-align:right"><div class="pb-pr">'+fmt(it.final_line_price)+'</div><button class="pb-rm" data-pb-line="'+(x+1)+'" data-pb-q="0">Eltávolítás</button></div></div>';
    }).join('');
    var upsellHtml=buildUpsellHtml(cart);
    if(upsellHtml){box.insertAdjacentHTML('beforeend',upsellHtml);}
  }
  var sub=$('pb-sc-sub'),tot=$('pb-sc-total'),ship=$('pb-sc-shipv');
  if(sub)sub.textContent=fmt(cart.total_price);
  if(tot)tot.textContent=fmt(cart.total_price);
  var msg=$('pb-sc-shipmsg'),bar=$('pb-sc-shipbar');
  var free=cart.total_price>=FREE_SHIP;
  if(ship)ship.textContent=cart.item_count?(free?'INGYENES 🎉':'a pénztárnál számoljuk'):'—';
  if(msg){
    if(!cart.item_count){msg.innerHTML='🚚 Ingyenes szállítás 50 000 Ft felett';}
    else if(free){msg.innerHTML='🎉 <b>Gratulálunk!</b> A szállítást mi álljuk — ingyenes kiszállítás!';}
    else{msg.innerHTML='🚚 Még <b>'+fmt(FREE_SHIP-cart.total_price)+'</b> az ingyenes szállításig';}
  }
  if(bar)bar.style.width=Math.min(100,cart.total_price/FREE_SHIP*100)+'%';
}
document.addEventListener('click',function(ev){
  var b=ev.target.closest('[data-pb-line]');
  if(!b)return;
  fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:+b.getAttribute('data-pb-line'),quantity:+b.getAttribute('data-pb-q')})})
    .then(function(r){return r.json();}).then(renderCart);
});
window.pbRefreshCart=refreshCart;

/* ---- add to cart intercept ---- */
document.addEventListener('submit',function(ev){
  var f=ev.target.closest('form.pb-atc-form');
  if(!f)return;
  ev.preventDefault();
  var btn=f.querySelector('[type=submit]');if(btn)btn.disabled=true;
  fetch('/cart/add.js',{method:'POST',body:new FormData(f)})
    .then(function(r){if(!r.ok)throw r;return r.json();})
    .then(function(){toast('Hozzáadva a kosárhoz! ✓');openCart();})
    .catch(function(r){
      if(r.json){r.json().then(function(e){toast(e.description||e.message||'Hiba történt — próbáld újra');});}
      else toast('Hiba történt — próbáld újra');
    })
    .then(function(){if(btn)btn.disabled=false;});
});

/* ---- PDP: kúra/variáns választó ---- */
function initPdp(){
  var root=document.querySelector('[data-pb-pdp]');if(!root)return;
  var dataEl=$('pb-variants');if(!dataEl)return;
  var variants=JSON.parse(dataEl.textContent);
  var qty=1,qtyOut=$('pb-qty-out');
  function sel(){var o=root.querySelector('.pb-opt.pb-sel');return variants.find(function(v){return String(v.id)===o.getAttribute('data-vid');});}
  function upd(){
    var v=sel();if(!v)return;
    var idIn=root.querySelector('input[name=id]');if(idIn)idIn.value=v.id;
    var pEl=$('pb-atc-price');if(pEl)pEl.textContent=fmt(v.price*qty);
    var sEl=$('pb-sticky-price');if(sEl)sEl.textContent=fmt(v.price*qty);
    var st=$('pb-stockline');
    if(st){
      if(!v.available){st.innerHTML='❌ Jelenleg nem elérhető';st.className='pb-stock';}
      else if(v.tracked&&v.qty>0&&v.qty<=10){st.innerHTML='<span class="pb-pulse"></span> Már csak <b>&nbsp;'+v.qty+' db&nbsp;</b> van raktáron!';st.className='pb-stock';}
      else{st.innerHTML='✓ Raktáron — 1–2 munkanapon belül feladjuk';st.className='pb-stock pb-ok';}
    }
    var atc=root.querySelector('form.pb-atc-form [type=submit]');
    if(atc){atc.disabled=!v.available;}
  }
  root.querySelectorAll('.pb-opt').forEach(function(o){
    o.addEventListener('click',function(){
      root.querySelectorAll('.pb-opt').forEach(function(x){x.classList.remove('pb-sel');});
      o.classList.add('pb-sel');upd();
    });
  });
  root.querySelectorAll('[data-pb-qty]').forEach(function(b){
    b.addEventListener('click',function(){qty=Math.max(1,qty+ +b.getAttribute('data-pb-qty'));if(qtyOut)qtyOut.textContent=qty;var qIn=root.querySelector('input[name=quantity]');if(qIn)qIn.value=qty;upd();});
  });
  var sticky=$('pb-sticky-atc');
  if(sticky){
    var pricebox=root.querySelector('.pb-pricebox');
    if('IntersectionObserver' in window && pricebox){
      new IntersectionObserver(function(es){
        var show=!es[0].isIntersecting;
        sticky.classList.toggle('pb-show',show);
        document.body.classList.toggle('pb-sticky-open',show);
      },{threshold:0}).observe(pricebox);
    }
    sticky.querySelector('button').addEventListener('click',function(){
      var f=root.querySelector('form.pb-atc-form');
      if(f)f.dispatchEvent(new Event('submit',{bubbles:true,cancelable:true}));
    });
  }
  upd();
}

/* ---- AI chat állapotfigyelés ---- */
function initChatWatch(){
  function apply(){
    var btn = document.querySelector('.Avada-Faqs_Button');
    var isOpen = !!(btn && btn.classList.contains('opened'));
    document.body.classList.toggle('pb-chat-open', isOpen);
  }
  var mo = new MutationObserver(function(muts){
    for(var i=0;i<muts.length;i++){
      var t = muts[i].target;
      if(t && t.classList && t.classList.contains('Avada-Faqs_Button')){apply();return;}
    }
  });
  mo.observe(document.body, {subtree:true, attributes:true, attributeFilter:['class']});
  apply();
}

/* ---- billentyűzet-figyelés ---- */
function initKeyboardWatch(){
  if(!window.visualViewport)return;
  var vv = window.visualViewport;
  var baseline = vv.height;
  var tmr;
  function check(){
    var shrink = baseline - vv.height;
    document.body.classList.toggle('pb-kbd-open', shrink > 120);
  }
  vv.addEventListener('resize', function(){ clearTimeout(tmr); tmr = setTimeout(check, 60); });
  window.addEventListener('orientationchange', function(){ setTimeout(function(){ baseline = vv.height; check(); }, 400); });
}

/* ---- init ---- */
function init(){
  ['pb-overlay','pb-sidecart','pb-toast','pb-sticky-atc'].forEach(function(id){
    var els=document.querySelectorAll('#'+id);
    for(var i=1;i<els.length;i++)els[i].remove();
    if(els[0]&&els[0].parentElement!==document.body)document.body.appendChild(els[0]);
  });
  observeAll();initCountdowns();initPdp();refreshCart();initChatWatch();initKeyboardWatch();
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
document.addEventListener('shopify:section:load',function(){observeAll();initCountdowns();});
})();
